<template>
    <div class="myProgress">
        <div class="van-progress">
            <div class="step" :class="[{red: percentage <= 30},{animation: time !== 0}]" :style="'width:'+percentage+'%'"></div>
        </div>
        <span>{{date}}</span>
    </div>
</template>

<script>
export default {
    name: 'my-progress',
    props:['percentage','time'],
    data(){
        return {
            date:'',
            _time: '',
            timer: null
        }
    },
    created(){
        var that = this;
        that._time = that.time;
        // that.countTime();
    },
    watch: {
        time:function (param) {
            this._time = param;
            this.s_to_m();
          }
    },
    methods:{
        // 倒计时
        countTime(){
            // this.time -= 1;
            var that = this;
            that.timer = setInterval(()=>{
                that._time -= 1;
                that.s_to_m();
                if(that._time<=0){
                    clearInterval(that.timer)
                }
            },1000)
        },
        // 秒转分
        s_to_m(){
            var that = this
            var sce = that._time % 60 ;
            sce = sce < 10 ? '0' + sce : sce
            var min = parseInt(that._time / 60);
            min = min < 10 ? '0'+ min : min
            that.date = min + ':' + sce
        }
    }
}
</script>

<style>
    .myProgress{
        width: 100%;
        display: flex;
    }
    .van-progress{
        width: 90%;
        height: 10px;
        position: relative;
        margin-left: 5%;
        margin-right: 10px;
        border-radius: 5px;
        background-color: #e1e6ea;
    }
    .myProgress .van-progress .step{
        height: 10px;
        border-radius: 5px;
        position: absolute;
        background-color: #5576ab;
        
    }
    .animation{
        transition: all 1s linear;
    }
    .red{
        background-color: #f00!important;
    }
    .myProgress span{
        font-family:PingFangSC-Regular;
        font-size:13px;
        color:#000000;
    }
</style>



// WEBPACK FOOTER //
// src/components/van-progress.vue